import React, { useMemo } from 'react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { Breadcrumbs } from 'flipper-ui'
import { Sidebar } from '@core/components/sidebar/Sidebar'
import UserOptions from '@core/components/user-options/UserOptions'
import { getPaths } from '@core/lib/helpers'
import logoWhite from '@public/images/logo-white.svg'
import {
    AppBar,
    BreadcrumbLink,
    FlexExpanded,
    FlexGrow,
    LogoImage,
    SubHeader,
    Wrapper
} from '@core/commonStyles'

interface IProps {
    children: ReactNode
}

const LayoutV1 = (props: IProps) => {
    const { t } = useTranslation()
    const location = useLocation()

    const pathMapping = useMemo(() => getPaths(t), [t])

    const linkWrapper = (link: string, label: string) => (
        <BreadcrumbLink key={link} to={link}>
            {label}
        </BreadcrumbLink>
    )

    return (
        <FlexGrow>
            <AppBar position='sticky' elevation={4}>
                <FlexGrow>
                    <LogoImage alt='Portal' src={logoWhite} />
                </FlexGrow>

                <UserOptions />
            </AppBar>

            <FlexExpanded>
                <Sidebar />

                <FlexGrow>
                    <SubHeader id='page-subheader'>
                        <Breadcrumbs
                            homeId='-'
                            pathMapping={pathMapping}
                            linkWrapper={linkWrapper}
                            pathname={location.pathname}
                        />
                    </SubHeader>

                    <Wrapper>{props.children}</Wrapper>
                </FlexGrow>
            </FlexExpanded>
        </FlexGrow>
    )
}

export default LayoutV1
